import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Box } from '../../components';
import { PageWithTabs } from '../../layouts';
import ContactUsForm from '../../forms/contactUs/ContactUsForm';
import { Query, Mutation } from 'react-apollo';
import GetContactUs from '../../graphql/queries/GetContactUs';
import UpdateContactUs from '../../graphql/mutations/UpdateContactUs';
import CreateContactUs from '../../graphql/mutations/CreateContactUs';
import GetAllContactUs from '../../graphql/queries/GetAllContactUs';

interface MatchParams {
  id: string;
}

type Props = RouteComponentProps<MatchParams>;

const CONTACT_US_TABS = [{ title: 'Details', to: (id?: string) => `/contact-us/${id ? id : 'create-new'}/details` }];

const CreateEditContactUs: React.FC<Props> = ({ match, history, location }) => {
  const isEditing = !location.pathname.includes('create-new');

  console.log('CreateEditContactUs - Match Params:', match.params);
  console.log('CreateEditContactUs - Current ID:', match.params.id);
  console.log('CreateEditContactUs - Is Editing:', isEditing);
  console.log('CreateEditContactUs - Current Path:', location.pathname);

  return (
    <PageWithTabs
      tabs={CONTACT_US_TABS.map((tab) => ({
        ...tab,
        to: typeof tab.to === 'function' ? tab.to(match.params.id) : tab.to,
      }))}
    >
      <Box flexDirection="row" p={4}>
        {isEditing ? (
          <Query
            query={GetContactUs}
            variables={{
              contactUsId: match.params.id,
            }}
          >
            {({ loading: queryLoading, error, data }) => {
              console.log('CreateEditContactUs - Query Response:', {
                loading: queryLoading,
                error,
                data,
                variables: { contactUsId: match.params.id },
              });

              if (error) {
                console.error('CreateEditContactUs - Query Error:', error);
              }

              return (
                <Mutation
                  mutation={UpdateContactUs}
                  refetchQueries={[{ query: GetAllContactUs }]}
                  onCompleted={() => {
                    console.log('CreateEditContactUs - Update Completed');
                    history.push('/contact-us');
                  }}
                >
                  {(updateContactUs, { loading: mutationLoading }) => (
                    <ContactUsForm
                      initialValues={data && data.contactUs}
                      loading={queryLoading || mutationLoading}
                      error={error}
                      formType="edit"
                      mutation={(values) => {
                        console.log('CreateEditContactUs - Update Values:', values);
                        return updateContactUs({
                          variables: {
                            updateContactUsId: match.params.id,
                            data: {
                              name: values.name,
                              number: values.number,
                              email: values.email,
                              status: values.status.value,
                            },
                          },
                        });
                      }}
                    />
                  )}
                </Mutation>
              );
            }}
          </Query>
        ) : (
          <Mutation
            mutation={CreateContactUs}
            refetchQueries={[{ query: GetAllContactUs }]}
            onCompleted={() => {
              history.push('/contact-us');
            }}
          >
            {(createContactUs, { loading, error }) => (
              <ContactUsForm
                loading={loading}
                error={error}
                formType="create"
                mutation={(values) =>
                  createContactUs({
                    variables: {
                      data: {
                        name: values.name,
                        number: values.number,
                        email: values.email,
                        status: values.status.value,
                      },
                    },
                  })
                }
              />
            )}
          </Mutation>
        )}
      </Box>
    </PageWithTabs>
  );
};

export default CreateEditContactUs;



// WEBPACK FOOTER //
// ./src/containers/contactUs/CreateEditContactUs.tsx